import React from 'react';
// import TranslationProvider from '../../hooks/useTranslation';

const Layout = ({ children, ...rest }) => {
  return <>{children}</>;
};

export default Layout;
